import type {
  FilterConditionPluginSpecification,
} from '../filter.plugin';
import {
  FilterConditionPluginImpl
} from '../filter.plugin';
import type {
  BdCondition,
} from '@bindoc-projects/condition-domain-lib';
import {
  BdYearsCondition,
} from '@bindoc-projects/condition-domain-lib';
import { BdEquals } from '@bindoc-projects/util-domain-lib';

export const FilterConditionDismissalYearPluginType: FilterConditionPluginSpecification<
  number,
  FilterConditionDismissalYearDto,
  BdYearsCondition
> = {
  type: 'dismissalYear',
  category: 'case',
  displayName: { de: 'Entlass Jahr' },
  sortingIndex: 8,
  occurrence: 'multiple',
  fromObject(
    obj: FilterConditionDismissalYearDto,
  ): FilterConditionPluginImpl<number> {
    return new FilterConditionDismissalYearPlugin(obj.year);
  },
  fromCondition(
    jsonObj: BdYearsCondition,
  ): FilterConditionPluginImpl<number> {
    if (jsonObj.includes && jsonObj.includes.length === 1) {
      return new FilterConditionDismissalYearPlugin(jsonObj.includes[0]);
    } else {
      throw new Error('Missing DismissalYear');
    }
  },
  newInstance(): FilterConditionPluginImpl<number> {
    return new FilterConditionDismissalYearPlugin(new Date().getFullYear());
  },
};

export class FilterConditionDismissalYearPlugin extends FilterConditionPluginImpl<
  number,
  FilterConditionDismissalYearDto
> {
  public static override Specification: FilterConditionPluginSpecification<
    number,
    FilterConditionDismissalYearDto,
    BdYearsCondition
  > = FilterConditionDismissalYearPluginType;

  constructor(private year: number) {
    super(FilterConditionDismissalYearPluginType.type);
  }

  clone(): FilterConditionDismissalYearPlugin {
    return new FilterConditionDismissalYearPlugin(this.year);
  }

  override equals(other: FilterConditionDismissalYearPlugin): boolean {
    return super.equals(other) && BdEquals.equals(this.year, other.year);
  }

  override validationToText(): string {
    if (this.year) {
      return '';
    } else {
      return 'Entlass-Jahr auwählen';
    }
  }

  toCondition(): BdCondition | null {
    return new BdYearsCondition([this.year], []);
  }

  toJSON(): FilterConditionDismissalYearDto | null {
    return {
      type: this.type,
      year: this.year,
    };
  }

  toText(): string | null {
    return 'Entlass-Jahr';
  }

  toValue(): number {
    return this.year;
  }
}

interface FilterConditionDismissalYearDto {
  type: string;
  year: number;
}
